import { Alert, type AlertProps, Typography } from "@mui/material";
import { Card, markdownToHtmlSync } from "@ssf/components";
import { useTranslation } from "react-i18next";

const severities = ["error", "warning", "info"] as const;

export const Announcement = (props: AlertProps) => {
  const { t } = useTranslation("Announcement");

  return (
    <>
      {severities.map(
        (severity) =>
          t(`content_${severity}`) && (
            <Card
              key={severity}
              disablePadding
              paperProps={{ sx: { svg: { mt: 0.25 } } }}
            >
              <Alert key={severity} severity={severity} {...props}>
                <Typography
                  variant="body1"
                  sx={{ "> p": { m: 0 } }}
                  dangerouslySetInnerHTML={{
                    __html: markdownToHtmlSync(
                      t(`content_${severity}`),
                    ).value.toString(),
                  }}
                />
              </Alert>
            </Card>
          ),
      )}
    </>
  );
};
